import { motion } from "framer-motion";
import { Percent, Globe2, PiggyBank, Smartphone } from "lucide-react";

const advantages = [
  {
    icon: Percent,
    title: "Reduceri în România și în lume",
    text: "Folosești cardul tău BRD-ISIC pentru a accesa beneficiile ISIC la mii de parteneri, de la restaurante și magazine până la transport, muzee, călătorii și servicii utile.",
  },
  {
    icon: Globe2,
    title: "Recunoaștere internațională",
    text: "ISIC este singura legitimație internațională de elev sau student recunoscută la nivel global și prezentă în peste 130 de țări.",
  },
  {
    icon: PiggyBank,
    title: "Facilități bancare pentru elevi și studenți",
    text: "BRD-ISIC vine la pachet și cu beneficii bancare dedicate tinerilor, comunicate de BRD, precum administrare gratuită în anumite condiții, plăți și încasări în lei, mobile banking și retrageri de numerar.",
  },
  {
    icon: Smartphone,
    title: "Alive App",
    text: "Ai legitimația digitală în telefon și găsești mai ușor reducerile disponibile, direct din aplicație.",
  },
];

export const Advantages = () => (
  <section id="beneficii" className="bg-white py-16 md:py-24" data-testid="advantages-section">
    <div className="max-w-6xl mx-auto px-5 md:px-8">
      <div className="max-w-3xl">
        <h2 className="font-heading font-black text-3xl md:text-4xl tracking-tight text-zinc-900">
          Ce primești cu BRD-ISIC?
        </h2>
      </div>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
        {advantages.map((a, i) => (
          <motion.div
            key={a.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            data-testid={`advantage-card-${i}`}
            className="group rounded-2xl border border-zinc-200 bg-white p-8 hover:-translate-y-1 hover:shadow-xl hover:border-brand/40 transition-[transform,box-shadow,border-color] duration-300"
          >
            <div className="w-12 h-12 rounded-xl bg-brand/10 flex items-center justify-center mb-5 group-hover:bg-brand transition-colors duration-300">
              <a.icon className="w-6 h-6 text-brand group-hover:text-white transition-colors duration-300" />
            </div>
            <h3 className="font-heading font-bold text-xl text-zinc-900">{a.title}</h3>
            <p className="mt-3 text-sm md:text-base text-zinc-600 leading-relaxed">{a.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
